function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipRule: "evenodd",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.2 21.6c0 11.93-9.67 21.6-21.6 21.6S0 33.53 0 21.6 9.67 0 21.6 0s21.6 9.67 21.6 21.6z",
  fill: "#f43e37"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.8 21.8c0-9.389 7.611-17 17-17s17 7.611 17 17h-4.25c0-7.042-5.709-12.75-12.75-12.75S9.05 14.758 9.05 21.8s5.708 12.75 12.75 12.75v4.25c-9.389 0-17-7.611-17-17zm17 10.2c-5.633 0-10.2-4.567-10.2-10.2 0-5.633 4.567-10.2 10.2-10.2S32 16.167 32 21.8h-3.71a6.49 6.49 0 1 0-6.49 6.491z",
  fill: "#fff"
}));

function SvgPocketcast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 2500,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.2 43.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketcast);
export default __webpack_public_path__ + "static/media/pocketcast.a699d166.svg";
export { ForwardRef as ReactComponent };